import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import AdminPartnerSelect from "../Components/AdminPartnerSelect";

/**
 * Admin Home — placeholder until backend metrics/upload activity is wired.
 * Partner selector matches other admin screens; no floor-plan analytics on this page yet.
 */
const AdminHomeDashboard = () => {
  return (
    <Box sx={{ width: "100%", maxWidth: "100%", overflow: "hidden" }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "center" }}
        justifyContent="space-between"
        gap={2}
        mb={3}
        flexWrap="wrap"
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" fontWeight={700}>
            Home
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Overview and activity for the selected partner.
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "100%", sm: 300 }, maxWidth: "100%", flexShrink: 0 }}>
          <AdminPartnerSelect />
        </Box>
      </Stack>

      <Card
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 3,
          transition: "box-shadow 0.15s, border-color 0.15s",
          "&:hover": {
            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
            borderColor: "text.disabled",
          },
        }}
      >
        <CardContent sx={{ py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 2.5 } }}>
          <Typography
            variant="body1"
            color="text.secondary"
            align="center"
            sx={{ lineHeight: 1.6, px: { xs: 0.5, sm: 0 } }}
          >
            Backend endpoint not yet available
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminHomeDashboard;
